import Vue from 'vue';
import { account, Client, users, suppliers, passwords } from '@/api'
import * as Cookies from 'js-cookie'


/* eslint no-param-reassign: ["error"] */
const currentState = {
  user: {},
  status: '',
  token: localStorage.getItem('token') || '',
};

const mutations = {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, { token, user }) {
    state.status = 'success';
    state.token = token;
    state.user = user;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
  },
  auth_error(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
    state.token = '';
    state.user = {};
    localStorage.removeItem('token');
  },
  SET_USER(state, user) {
    state.user = user
  },
};

const actions = {
  async attempt({ dispatch }) {
    await dispatch('refreshToken')
    await dispatch('me')
  },
  async refreshToken() {
    await users.refreshToken()

    const xsrfToken = Cookies.get('XSRF-TOKEN')
    Client.setXSRFToken(xsrfToken)
  },

  async me({ commit }) {
    try {
      const user = await account.show();

      commit('SET_USER', user.data)
    } catch (error) {
      return error
    }
  },
  async login({ commit, dispatch }, params) {
    try {
      const response = await users.login(params)
      commit('SET_USER', response.data)
    } catch (error) {
      commit('auth_error');
    }
  },
  async forgot({ commit, dispatch }, params) {
    return await users.forgot(params)
  },
  async resetPassword({ commit, dispatch }, params) {
    return await passwords.update(params)
  },
  async getUser({ commit }) {
    try {
      const { data } = await account.show();
      commit('auth_success', {
        token: null,
        user: data,
      });
    } catch (error) {
      commit('auth_error');
    }
  },
  async doLogout({commit}) {
    await users.logout()
    commit('logout')
  },
  async setAutoAddToInvoice({ commit }) {
    try {
      await suppliers.toggleAutoAddToInvoice();
    } catch (error) {
      commit('auth_error');
    }
  },
};

const getters = {
  isLoggedIn: state => state.user.id !== undefined,
  authStatus: state => state.status,
  getUser: state => state.user,
  getSupplier: state => state.user.supplier,
  isRoleSupplier: state => state.user.id !== undefined && state.user.roles[0] !== undefined && state.user.roles[0] === 'Supplier',
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
